export default __webpack_public_path__ + "static/media/ColorAndContrast_Examples.5d6c8977.png";